import { isDraftSaveAction } from '../../../Draft'
import { FormModalConfirmation } from '../../../Form'
import { EmailDraftCloseActionSelectModal } from '../../EmailDraftCloseActionSelectModal'
import { useEmailDraft } from '../useEmailDraft'

export function useEmailCreationFormConfirmation({ onClose, onSubmitConfirm }) {
  const { draftId: emailDraftId, setDraft: setEmailDraft } = useEmailDraft()

  function handleSubmitConfirm(values, files, action) {
    setEmailDraft(isDraftSaveAction(action) ? values : null, 0)

    onSubmitConfirm?.(values, files, action)
    onClose()
  }

  return {
    Confirmation: emailDraftId
      ? EmailDraftCloseActionSelectModal
      : FormModalConfirmation,
    handleSubmitConfirm,
  }
}
